// extracted by mini-css-extract-plugin
module.exports = {"CSO_personal_content":"personal_CSO_personal_content__pyA1z"};